import { useApiClient } from "../components/useApiClient";
import useAuthToken from "../functions/useAuthToken";
import type { LicenseCheck } from "../models/License";

export const useLicenseChecker = () => {

    const getAccessToken = useAuthToken();
    const { getWithParam } = useApiClient();

    const canAdd = async (
        resourceType: "client" | "portfolio" | "artwork"
    ): Promise<LicenseCheck> => {

        const accessToken = await getAccessToken();

        if (!accessToken) {
            return {
                allowed: false,
                resource: resourceType,
                limitName: "",
                current: 0,
                max: 0,
                message: "Unable to verify license.",
                upgradeAvailable: false,
            };
        }

        try {
            const result = await getWithParam<LicenseCheck>(
                "licensing/can-add",
                accessToken,
                resourceType
            );

            return result;

        } catch (err) {

            return {
                allowed: false,
                resource: resourceType,
                limitName: "",
                current: 0,
                max: 0,
                message: "License check failed.",
                upgradeAvailable: false,
            };
        }
    };

    return { canAdd };
};